import { DropzoneFullScreenProtected } from '@components'

import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUploadAttachments } from '@features/attachments/hooks/useUploadAttachments'
import { ExpensesReceiptUploadSources } from '@views/receipts/enums/tracking'
import { useReceiptUploadTracking } from '@views/receipts/hooks/useReceiptUploadTracking'

import { Scope } from '../../../../../../../enums/scope'

export const BillsDropzone = (): ReactElement => {
  const { t } = useTranslation()
  const trackReceiptUpload = useReceiptUploadTracking({
    source: ExpensesReceiptUploadSources.PurchaseListFullScreenDragAndDrop,
  })

  const { isUploading, progress, uploadFiles } = useUploadAttachments({
    onSuccess: () => {
      trackReceiptUpload()
    },
  })

  const handleFileDrop = useCallback(
    (files: File[]) => {
      uploadFiles(files)
    },
    [uploadFiles],
  )

  return (
    <DropzoneFullScreenProtected
      scopes={Scope.BillAttachmentWrite}
      isUploading={isUploading}
      forceActive={isUploading}
      onDrop={handleFileDrop}
      uploadingText={t('ds.dropzone.uploading_with_counter', {
        current: progress.current,
        total: progress.total,
      })}
    />
  )
}
